import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { addEvents } from 'slice/eventsSlice';

const AddEvent = () => {
    const [formData, setFormData] = useState({
        heading: '',
        sub_heading: '',
        image: null,
        file: null,
        is_active: 1,
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const dispatch = useDispatch()
    const { loading, error } = useSelector((state) => state.events);
    const navigate = useNavigate()
    const prevLoadingRef = useRef(null);

    useEffect(() => {
        if (prevLoadingRef.current === null) {
            prevLoadingRef.current = loading;
            return;
        }

        const wasLoading = prevLoadingRef.current;
        prevLoadingRef.current = loading;

        if (isSubmitting && wasLoading === true && loading === false) {
            setIsSubmitting(false);
            if (!error) {
                toast.success('Event added successfully!');
                navigate('/events');
            } else {
                toast.error(typeof error === 'string' ? error : 'Failed to add event');
            }
        }
    }, [loading]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'file' ? e.target.files[0] : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.heading || !formData.image) {
            toast.error('Heading and Image are required');
            return;
        }

        const formDataToSend = {
            heading: formData.heading,
            sub_heading: formData.sub_heading || '',
            is_active: formData.is_active,
            image: formData.image,
            file: formData.file || null
        };

        setIsSubmitting(true);
        dispatch(addEvents(formDataToSend));
    };

    return (
        <div className="container-fluid px-4 py-4">
            <div className="card shadow border-0">
                <div className="card-header bg-primary text-white py-3">
                    <h5 className="mb-0">Add New Event</h5>
                </div>
                <div className="card-body p-4">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-md-6 mb-4">
                                <label htmlFor="eventHeading" className="adminlables">Event Heading</label>
                                <input
                                    type="text"
                                    id="eventHeading"
                                    name="heading"
                                    value={formData.heading}
                                    className="form-control"
                                    placeholder="Enter event heading"
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="col-md-6 mb-4">
                                <label htmlFor="eventSubHeading" className="adminlables">Sub Heading</label>
                                <input
                                    type="text"
                                    id="eventSubHeading"
                                    name="sub_heading"
                                    value={formData.sub_heading}
                                    className="form-control"
                                    placeholder="Enter sub heading (optional)"
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-6 mb-4">
                                <label htmlFor="eventImage" className="adminlables">Event Image</label>
                                <input
                                    type="file"
                                    id="eventImage"
                                    name="image"
                                    accept="image/*"
                                    className="form-control btn-block filebg"
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="col-md-6 mb-4">
                                <label htmlFor="eventFile" className="adminlables">Attachment File (optional)</label>
                                <input
                                    type="file"
                                    id="eventFile"
                                    name="file"
                                    accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.zip,.ppt,.pptx"
                                    className="form-control btn-block filebg"
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-6 mb-4">
                                <label htmlFor="is_active" className="adminlables">Status</label>
                                <select id="is_active" name="is_active" value={formData.is_active} className="form-control" onChange={handleChange}>
                                    <option value={1}>Active</option>
                                    <option value={0}>Inactive</option>
                                </select>
                            </div>
                        </div>

                        <div className="d-flex justify-content-end gap-3 mt-4">
                            <button type="button" className="btn btn-light px-4" onClick={() => navigate('/events')} disabled={isSubmitting}>
                                Cancel
                            </button>
                            <button type="submit" className="btn btn-primary px-5" disabled={isSubmitting}>
                                {isSubmitting ? 'Adding...' : 'Add Event'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default AddEvent
